module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('segmentation-dashboard', {
    attrs: {
      "summary": _vm.segmentSummary,
      "insights": _vm.segmentInsights,
      "segment-stats": _vm.segmentStats.segments,
      "segment-tags": _vm.segmentTags.segments,
      "listeners": _vm.filterListeners,
      "aggregate": _vm.aggregateListeners,
      "cross-channel": _vm.crossChannelEngagement,
      "selected-listener": _vm.selectedListenerProfile,
      "recommendation-result": _vm.recommendationResult,
      "base-aggregate": _vm.baseAggregate,
      "is-search": !!_vm.searchQuery,
      "completeness": _vm.profileCompleteness,
      "recommend-error": _vm.recommendError,
      "credits-exhausted": _vm.creditsExhausted,
      "enriching": _vm.enriching,
      "enrich-credits-exhausted": _vm.enrichCreditsExhausted,
      "segment-freshness": _vm.segmentFreshness,
      "refreshing": _vm.refreshing,
      "loading-completeness": _vm.$apollo.queries.profileCompleteness.loading,
      "loading-summary": _vm.$apollo.queries.segmentSummary.loading,
      "load-total": _vm.loadNames.length,
      "load-done": _vm.loadNames.length - _vm.pendingLoads.length,
      "load-errors": _vm.loadErrorMessages,
      "segmentation-enabled": _vm.segmentationEnabled || !_vm.pluginsKnown,
      "loading-insights": _vm.$apollo.queries.segmentInsights.loading,
      "loading-listeners": _vm.$apollo.queries.filterListeners.loading,
      "loading-aggregate": _vm.$apollo.queries.aggregateListeners.loading
    },
    on: {
      "refresh": _vm.handleRefresh,
      "filter": _vm.handleFilter,
      "load-more": _vm.handleLoadMore,
      "recommend": _vm.handleRecommend,
      "recommend-cleared": _vm.handleRecommendCleared,
      "recommendation-used": _vm.handleRecommendationUsed,
      "enrich": _vm.handleEnrich,
      "find-similar": _vm.handleFindSimilar,
      "apply-inferred": _vm.handleApplyInferred,
      "review-link": _vm.handleReviewLink,
      "replace-demographic": _vm.handleReplaceDemographic,
      "deploy": _vm.handleDeploy,
      "open-listener": _vm.handleOpenListener,
      "close-listener": _vm.handleCloseListener,
      "view-profile": _vm.handleViewProfile
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88c980f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/segmentation/SegmentationDashboardContainer.vue
// module id = 3365
// module chunks = 3